module.exports = __webpack_public_path__ + "static/img/10bac.c5c4fd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/10bac.jpg
// module id = zicN
// module chunks = 1